module.exports = __webpack_public_path__ + "static/media/basket_sunflore_illu_cut.31df0a73.jpg";